import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ROUTES_ARCHIVOS } from '../constants/constant.model';
import { Observable } from 'rxjs';
import { iArticulo } from '../models/iarticulomodel';
import { iClaseArticulo } from '../models/iclase-articulo.model'
import { iClaseCodigoArticulo } from '../models/iclase-codigo-articulo.model'
import { ImagenBase64 } from '../models/imagenBase64.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { StorageService } from './storage.service';

@Injectable({
    providedIn: 'root'
})
export class ArticuloService {
    public sessionInfo = JSON.parse(StorageService.getSession());
    public ciaId = this.sessionInfo.id_cia;
    constructor(
        private apiService: ApiService,
        private httpClient: HttpClient
    ) { }

    public obtenerItemAnticipo(moneda: string) {
        return this.httpClient.get(environment.serviceUrl + "articulo/emision-anticipo?moneda=" + moneda, { observe: 'response' })
    }

    insertar(data: iArticulo): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.executePostJson(data).pipe();
    }

    modificar(data: iArticulo): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.executePutJson(data).pipe();
    }

    eliminar(tipinv: any, codart: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.executeDeleteJson(`/${tipinv}/${encodeURIComponent(codart)}`)
    }

    buscar(tipinv: any, codart: any, descri: any, limit: any, offset: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.execGetQueryJson(`/buscar?tipinv=${tipinv}&descri=${encodeURIComponent(descri)}&codart=${encodeURIComponent(codart)}&limit=${limit}&offset=${offset}`)
    }
    buscar2(tipinv: any, codart: any, descri: any, limit: any, offset: any,soloactivos: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.execGetQueryJson(`/buscar?tipinv=${tipinv}&descri=${encodeURIComponent(descri)}&codart=${encodeURIComponent(codart)}&limit=${limit}&offset=${offset}&soloActivos=${soloactivos}`)
    }

    buscarNoIsc(tipinv: any, codart: any, descri: any, limit: any, offset: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.execGetQueryJson(`/buscar/lista-isc?tipinv=${tipinv}&descri=${encodeURIComponent(descri)}&codart=${encodeURIComponent(codart)}&limit=${limit}&offset=${offset}`)
    }

    buscarPorClases(_filter: any): Observable<any> {

        return this.httpClient.get(environment.serviceUrl + 
            "articulo/buscar-por-clases?tipo=" + _filter.tipo
            + "&tipinv=" + _filter.tipinv
            + "&codtit=" + _filter.codtit
            + "&codart=" + encodeURIComponent(_filter.codart)
            + "&descri=" + encodeURIComponent(_filter.descri)
            + (_filter.codprov != null ? ("&codprov=" + _filter.codprov) : "")
            + "&almacenes=" + _filter.almacenes
            + "&incstock=" + _filter.incstock
            + "&femisi=" + _filter.femisi
            + "&tipcamcab=" + _filter.tipcamcab
            + "&codmon=" + _filter.codmon
            + "&incigvcab=" + _filter.incigvcab, { observe: 'response' })
    }
    buscarPorClases_v2(_filter: any): Observable<any> {

        return this.httpClient.get(environment.serviceUrl + "articulo/buscar-por-clases-v2?tipo=" + _filter.tipo
            + "&tipinv=" + _filter.tipinv
            + "&codtit=" + _filter.codtit
            + "&codart=" + encodeURIComponent(_filter.codart)
            + "&descri=" + encodeURIComponent(_filter.descri)
            + (_filter.codprov != null ? ("&codprov=" + _filter.codprov) : "")
            + "&almacenes=" + _filter.almacenes
            + "&incstock=" + _filter.incstock
            + "&codmon=" + _filter.codmon
            + "&femisi=" + _filter.femisi
            + "&tipcamcab=" + _filter.tipcamcab
            + "&incigvcab=" + _filter.incigvcab
            + "&wglosa=" + encodeURIComponent(_filter.wglosa)
            + "&clase1=" + _filter.clase1
            + "&clase2=" + _filter.clase2
            + "&clase3=" + _filter.clase3
            + "&clase4=" + _filter.clase4
            + "&clase5=" + _filter.clase5
            + "&clase6=" + _filter.clase6
            , { observe: 'response' })
    }
    buscarPorClases_v3(_filter: any): Observable<any> {

        return this.httpClient.get(environment.serviceUrl + 
            "articulo/buscar-por-clases-v3?tipo=" + _filter.tipo
            + "&tipinv=" + _filter.tipinv
            + "&codtit=" + _filter.codtit
            + "&codart=" + encodeURIComponent(_filter.codart)
            + "&descri=" + encodeURIComponent(_filter.descri)
            + (_filter.codprov != null ? ("&codprov=" + _filter.codprov) : "")
            + "&almacenes=" + _filter.almacenes
            + "&incstock=" + _filter.incstock
            + "&femisi=" + _filter.femisi
            + "&tipcamcab=" + _filter.tipcamcab
            + "&codmon=" + _filter.codmon
            + "&incigvcab=" + _filter.incigvcab, { observe: 'response' })
    }
    buscarConStock(_filter:any):Observable<any>{
        return this.httpClient.get(environment.serviceUrl + "articulo/buscar-con-stock?tipo=" + _filter.tipo
        + "&tipinv=" + _filter.tipinv
        + "&codtit=" + _filter.codtit
        + "&codart=" + encodeURIComponent(_filter.codart)
        + "&descri=" + encodeURIComponent(_filter.descri)
        + (_filter.codprov != null ? ("&codprov=" + _filter.codprov) : "")
        + "&almacenes=" + _filter.almacenes
        + "&incstock=" + _filter.incstock
        + "&codmon=" + _filter.codmon
        + "&femisi=" + _filter.femisi
        + "&tipcamcab=" + _filter.tipcamcab
        + "&incigvcab=" + _filter.incigvcab
        + "&anyStock=" + _filter.anyStock, { observe: 'response' })
    }
    buscar_precio(tipinv: any, codart: any, codtit: any, codalm: any, codpro: string, codmon: string ): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.execGetQueryJson(`/${tipinv}/${encodeURIComponent(codart)}?codtit=${codtit}&codalm=${codalm}&codpro=${encodeURIComponent(codpro)}&codmon=${encodeURI(codmon)}`)
    }

    buscar_preciov2(tipinv: any, codart: any, codtit: any, codalm: any, codpro: string, codmon: string , femisi: any, tipcamcab: any, incigvcab : any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.execGetQueryJson(`/${tipinv}/${encodeURIComponent(codart)}?codtit=${codtit}&codalm=${codalm}&codpro=${encodeURIComponent(codpro)}&codmon=${encodeURI(codmon)}&femisi=${femisi}&tipcamcab=${tipcamcab}&incigvcab=${incigvcab}`)
    }

    get_codigo_barra(codigobarra: any, codtit: any, codalm: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url + '/codigobarra');
        return this.apiService.execGetQueryJson(`/${codigobarra}?codtit=${codtit}&codalm=${codalm}`)
    }

    obtener_articulo(tipinv: any, codart: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.execGetQueryJson(`/${tipinv}/${encodeURIComponent(codart)}`)
    }

    getListaPreciosArticulo(codart: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.execGetQueryJson(`/all/${encodeURIComponent(codart)}/precios-lavanderia`)
    }

    /**** ACTIVO FIJO *******/

    calculoDepreciacion(tipinv: number, codart: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url+`/${tipinv}/${encodeURIComponent(codart)}/activo-fijo/calculo-depreciacion`);
        return this.apiService.executePutJson('').pipe();
    }

    calculoDepreciacionRecalculo(tipinv: number, codart: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url+`/${tipinv}/${encodeURIComponent(codart)}/activo-fijo/calculo-depreciacion/recalculo`);
        return this.apiService.executePutJson('').pipe();
    }

    updateDepreciacion(tipinv: number, codart: string , data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url+`/${tipinv}/${encodeURIComponent(codart)}/depreciacion`);
        return this.apiService.executePutJson(data).pipe();
    }

    /************CONTROL DE STOCK */

    buscarControlStock(): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.execGetQueryJson(`/tipo-control-stock`)
    }

    buscarTipoControlStock(activo: any): Observable<any> {
        this.apiService.setUrlPathApi(`tipo-control-stock/buscar`);
        return this.apiService.execGetQueryJson(`?activo=${activo}`)
    }

    



    /*************ARTICULOS CLASES*******/
    get_tipoinventario_clase(tipinv: number): Observable<any> {
        this.apiService.setUrlPathApi('clases-genericas/articulo');
        return this.apiService.execGetQueryJson(`/${tipinv}/clases`)
    }

    eliminarClase(tipinv: any, clase: any): Observable<any> {
        this.apiService.setUrlPathApi('clases-genericas/articulo');
        return this.apiService.executeDeleteJson(`/${tipinv}/clases/${clase}`)
    }

    insertarClase(data: iClaseArticulo): Observable<any> {
        this.apiService.setUrlPathApi('clases-genericas/articulo/clases');
        return this.apiService.executePostJson(data).pipe();
    }

    obtenerClase(tipinv: any, clase: any): Observable<any> {
        this.apiService.setUrlPathApi('clases-genericas/articulo');
        return this.apiService.execGetQueryJson(`/${tipinv}/clases/${clase}`)
    }

    modificarClase(data: iClaseArticulo): Observable<any> {
        this.apiService.setUrlPathApi('clases-genericas/articulo/clases');
        return this.apiService.executePutJson(data).pipe();
    }
    /*************ARTICULOS CLASES CODIGO*******/

    getTipoInventarioCodigo(tipinv: number, clase: number): Observable<any> {
        this.apiService.setUrlPathApi('clases-genericas/articulo');
        return this.apiService.execGetQueryJson(`/${tipinv}/clases/${clase}/codigos`)
    }

    insertarClaseCodigo(data: iClaseCodigoArticulo): Observable<any> {
        this.apiService.setUrlPathApi('clases-genericas/articulo/clases/codigos');
        return this.apiService.executePostJson(data).pipe();
    }

    modificarClaseCodigo(data: iClaseCodigoArticulo): Observable<any> {
        this.apiService.setUrlPathApi('clases-genericas/articulo/clases/codigos');
        return this.apiService.executePutJson(data).pipe();
    }


    obtenerClaseCodigo(tipinv: any, clase: any, codigo: any): Observable<any> {
        this.apiService.setUrlPathApi('clases-genericas/articulo');
        return this.apiService.execGetQueryJson(`/${tipinv}/clases/${clase}/codigos/${codigo}`)
    }

    eliminarClaseCodigo(tipinv: any, clase: any, codigo: any): Observable<any> {
        this.apiService.setUrlPathApi('clases-genericas/articulo');
        return this.apiService.executeDeleteJson(`/${tipinv}/clases/${clase}/codigos/${codigo}`)
    }

    /******************TAB CLASE**************************/
    getClase(tipinv: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.execGetQueryJson(`/${tipinv}/clases`)
    }

    getClaseCodigo(tipinv: number, clase: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.execGetQueryJson(`/${tipinv}/clases/${clase}/codigos`)
    }

    delete_clase(tipinv: any, codart: any, clase: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.executeDeleteJson(`/${tipinv}/${encodeURIComponent(codart)}/clases/${clase}`)
    }

    /******************TAB ESPECIFICACIONES**************************/

    listEspecificaciones(tipinv: number): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.execGetQueryJson(`/${tipinv}/especificaciones`)

    }

    delete_especificacion(tipinv: any, codart: any, codesp: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.executeDeleteJson(`/${tipinv}/${encodeURIComponent(codart)}/especificaciones/${codesp}`)
    }


    /******************TAB LISTA DE PRECIOS**************************/

    listPrecios(tipinv: number, codart: string): Observable<any> {
        this.apiService.setUrlPathApi('lista-precios/list?');
        return this.apiService.execGetQueryJson(`tipinv=${tipinv}&codart=${encodeURIComponent(codart)}`)
    }

   

    /******************TAB CLASES GLOBALES**************************/


    getClasesGlobal(): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.execGetQueryJson(`/all/clases-global`)
    }

    getClaseCodigoGlobal(clase: number, descri: any, limit: any, offset: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url + `/all/clases-global/${clase}/codigos?`);
        return this.apiService.execGetQueryJson(`descri=${descri}&limit=${limit}&offset=${offset}`)
    }

    delete_clase_global(tipinv: any, codart: any, clase: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.executeDeleteJson(`/${tipinv}/${encodeURIComponent(codart)}/clases-global/${clase}`)
    }

    getClasesGlobalUNSPSC(segmento: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.execGetQueryJson(`/all/clases-global/UNSPSC?segmento=${segmento}`)
    }

    getClasesGlobalUNSPSCProducto(clase: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.execGetQueryJson(`/all/clases-global/UNSPSC/producto?clase=${clase}`)
    }

    /******************TAB CLASES ALTERNATIVAS **************************/

    getClasesAlternativa(descri:any): Observable<any> {
        this.apiService.setUrlPathApi(`clases-genericas/`);
        return this.apiService.execGetQueryJson(`clase-articulos-alternativo/buscar/${descri}`)
    }

    insertarClasesAlternativa(data: any): Observable<any> {
        this.apiService.setUrlPathApi(`clases-genericas/clase-articulos-alternativo`);
        return this.apiService.executePostJson(data).pipe();
    }

    delete_clase_altern(tipinv: any, codart: any, clase: any,codigo :any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.executeDeleteJson(`/${tipinv}/${encodeURIComponent(codart)}/clase-alternativa/${clase}?codigo=${codigo}`)
    }
    /******************TAB CLASES IMAGENES**************************/

    insertarImagenArticulo(tipinv: number, codart: string, imagenBase64: ImagenBase64): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url + `/${tipinv}/${encodeURIComponent(codart)}/imagen`);
        return this.apiService.executePostJson(imagenBase64).pipe();
    }


    deleteImagenArticulo(tipinv: number, codart: string, codigo: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.executeDeleteJson(`/${tipinv}/${encodeURIComponent(codart)}/imagen/${codigo}`)
    }

    obtenerImagenArticulo(tipinv: number, codart: string, codigo: number, cia: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url + `/${tipinv}/${encodeURIComponent(codart)}/public/imagen/${codigo}`);
        return this.apiService.execGetQueryJson(`?cia=${cia}.jpg`)
    }

    listaArticuloImagenes(tipinv: number, codart: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.execGetQueryJson(`/${tipinv}/${encodeURIComponent(codart)}/imagenes`)
    }
   /******************TAB ADJUNTOS**************************/

   insertarAdjuntoArticulo(data: any): Observable<any> {
    this.apiService.setUrlPathAdjuntos(`archivos/${this.ciaId}/articulo-adjunto`);
    return this.apiService.executePostJson(data).pipe();
}

actualizarAdjuntoArticulo(data: any): Observable<any> {
    this.apiService.setUrlPathAdjuntos(`archivos/${this.ciaId}/articulo-adjunto`);
    return this.apiService.executePostJson(data).pipe();
}

deleteAdjuntoArticulo(tipinv: number, codart: string, item: any): Observable<any> {
    this.apiService.setUrlPathAdjuntos(`archivos/${this.ciaId}/articulo-adjunto`);
    return this.apiService.executeDeleteJson(`/${item}?tipinv=${tipinv}&codart=${codart}`)
}

obtenerAdjuntoArticulo(tipinv: any, codart: any): Observable<any> {
    this.apiService.setUrlPathAdjuntos(`archivos/${this.ciaId}/articulo-adjuntos`);
    return this.apiService.execGetQueryJson(`?tipinv=${tipinv}&codart=${codart}`)
}

descargarAdjuntoArticulo(tipinv: number, codart: string, item: any): Observable<any> {
    this.apiService.setUrlPathAdjuntos(`archivos/${this.ciaId}/articulo-adjunto/public/descargar/`+item);
    return this.apiService.execGetQueryJsonPDF(`?tipinv=${tipinv}&codart=${codart}`).pipe();
}
    /******************ARTICULOS STOCK**************************/

    getStockv2(tipinv: number, codart: string, codalm: number): Observable<any> {
        this.apiService.setUrlPathApi('articulo/' + `${tipinv}/${encodeURIComponent(codart)}/stock`);
        return this.apiService.execGetQueryJson(`?codalm=${codalm}`)
    }

    /************************KARDEX*******************************/
    getKardex(tipinv: number, codart: any, periodo: any, mes: any, codalm: any, check: boolean, etiqueta: any, lote: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url + `/${tipinv}/${encodeURIComponent(codart)}/kardex`);
        return this.apiService.execGetQueryJson(`?periodo=${periodo}&mes=${mes}&codalm=${codalm}&checkTodos=${check}&etiqueta=${etiqueta}&lote=${lote}`)
    }

    busqueda_articulo_import_lp(tipinv: number, clase: number, codtit: number, codpro: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.execGetQueryJson(`/buscar_to_import_in_lprice?tipinv=${tipinv}&clase=${clase}&codtit=${codtit}&codpro=${codpro}`)
    }

    busqueda_articulo_import_lp_v2(tipinv: number, clase: number, codpro: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url);
        return this.apiService.execGetQueryJson(`/buscar_to_import_in_lprice_v2?tipinv=${tipinv}&clase=${clase}&codpro=${codpro}`)
    }

    public obtenerStock(tipinv: number, codart: string, codalm: number) {
        return this.httpClient.get(environment.serviceUrl + "articulo/" + tipinv + "/" + encodeURI(codart) + "/almacen/" + codalm + "/stock", { observe: 'response' },)
    }

    public sp_articulo_cotizaciones(query: any) {

        return this.httpClient.get(environment.serviceUrl + "articulo/cotizaciones?tipinv=" + query.tipinv + "&codart=" + encodeURI(query.codart)
            + "&codsuc=" + query.codsuc
            + "&codcli=" + ((query.codcli != undefined && query.codcli != null) ? encodeURIComponent(query.codcli) : "")
            + (query.fdesde != null ? ("&fdesde=" + query.fdesde) : "") 
            + (query.fhasta != null ? ("&fhasta=" + query.fhasta) : "") 
            + "&situac=" + ((query.situac != undefined && query.situac != null) ? encodeURIComponent(query.situac) : "")
            + "&limit=" + query.limit
            + "&offset=" + query.offset, { observe: 'response' })
    }

    public sp_articulo_ventas(query: any) {
        return this.httpClient.get(environment.serviceUrl + "articulo/ventas?tipinv=" + query.tipinv + "&codart=" + encodeURI(query.codart)
            + "&codsuc=" + query.codsuc
            + "&codcli=" + ((query.codcli != undefined && query.codcli != null) ? encodeURIComponent(query.codcli) : "")
            + (query.fdesde != null ? ("&fdesde=" + query.fdesde) : "") 
            + (query.fhasta != null ? ("&fhasta=" + query.fhasta) : "") 
            + "&limit=" + query.limit
            + "&offset=" + query.offset, { observe: 'response' })
    }

    public sp_articulo_compras(query: any) {
        return this.httpClient.get(environment.serviceUrl + "articulo/compras?tipinv=" + query.tipinv + "&codart=" + encodeURI(query.codart)
            + "&codsuc=" + query.codsuc
            + "&limit=" + query.limit
            + "&offset=" + query.offset, { observe: 'response' })
    }


    public sp_articulo_comprometidos(query: any) {
        return this.httpClient.get(environment.serviceUrl + "articulo/comprometido?tipinv=" + query.tipinv
            + "&codart=" + encodeURI(query.codart)
            + "&codalm=" + query.codalm
            + "&etiqueta=" + query.etiqueta, { observe: 'response' })
    }

    public sp_articulo_xrecibir(query: any) {
        return this.httpClient.get(environment.serviceUrl + "articulo/xrecibir?tipinv=" + query.tipinv
            + "&codart=" + encodeURI(query.codart)
            + "&codalm=" + query.codalm
            , { observe: 'response' })
    }


    public sp_articulo_lprecios_xprov(query: any) {
        return this.httpClient.get(environment.serviceUrl + "articulo/lprecios_xprov?tipinv=" + query.tipinv
            + "&codart=" + encodeURI(query.codart)
            , { observe: 'response' })
    }

    //SERVICIO PARA GLOSAS

    insertarGlosa(data: any): Observable<any> {
        this.apiService.setUrlPathApi('articulo-glosa');
        return this.apiService.executePostJson(data).pipe();
    }

    modificarGlosa(data: any): Observable<any> {
        this.apiService.setUrlPathApi('articulo-glosa');
        return this.apiService.executePutJson(data).pipe();
    }

    eliminarGlosa(tipinv: any, codart: any,tipo:any): Observable<any> {
        this.apiService.setUrlPathApi('articulo-glosa');
        return this.apiService.executeDeleteJson(`/${tipinv}/${encodeURIComponent(codart)}?tipo=${tipo}`)
    }

    obtenerGlosa(tipinv: any, codart: any,tipo:any): Observable<any> {
        this.apiService.setUrlPathApi('articulo-glosa');
        return this.apiService.execGetQueryJson(`/${tipinv}/${encodeURIComponent(codart)}?tipo=${tipo}`)
    }

    // buscarGlosa(tipinv: any, codart: any, descri: any, limit: any, offset: any): Observable<any> {
    //     this.apiService.setUrlPathApi('articulo-glosa');
    //     return this.apiService.execGetQueryJson(`/buscar?tipinv=${tipinv}&descri=${encodeURIComponent(descri)}&codart=${encodeURIComponent(codart)}&limit=${limit}&offset=${offset}`)
    // }

    emision_anticipo1(moneda: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url + "/emision-anticipo");
        return this.apiService.execGetQueryJson(`?moneda=${moneda}`)
    }

    //SERVICIO PARA EAN
    listEan(tipinv: number, codart: string): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url+'/codigo-ean/buscar?');
        return this.apiService.execGetQueryJson(`tipinv=${tipinv}&codart=${encodeURIComponent(codart)}`)
    }

    insertarEan(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url+'/codigo-ean');
        return this.apiService.executePostJson(data).pipe();
    }

    modificarEan(data: any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url+'/codigo-ean');
        return this.apiService.executePutJson(data).pipe();
    }

    eliminarEan(tipinv: any, codart: any,item:any): Observable<any> {
        this.apiService.setUrlPathApi(ROUTES_ARCHIVOS.articulo_CRUD_url+'/codigo-ean');
        return this.apiService.executeDeleteJson(`/${item}?tipinv=${tipinv}&codart=${encodeURIComponent(codart)}`)
    }

    ///////////////////////////////////

    exportarExcelPrecio( tipinv: any, clase: any, codtit: any, codpro: any, vencom: any,clase2:any,clase3:any,clase4:any,clase5:any,clase6:any): Observable<any> {
        this.apiService.setUrlPathApiReport('articulo/buscar_to_import_in_lprice/exportar-excel');
        return this.apiService.execGetQueryJsonPDF(`?tipinv=${tipinv}&clase=${clase}&codtit=${codtit}&codpro=${encodeURIComponent(codpro)}&vencom=${vencom}&clase2=${clase2}&clase3=${clase3}&clase4=${clase4}&clase5=${clase5}&clase6=${clase6}`);
    }

    exportarExcelPrecioClase( tipinv: any, clase: any, codtit: any, codpro: any, vencom: any,clase2:any,clase3:any,clase4:any,clase5:any,clase6:any): Observable<any> {
        this.apiService.setUrlPathApiReport('articulo/exportar-por-clase-para-importar/excel');
        return this.apiService.execGetQueryJsonPDF(`?tipinv=${tipinv}&clase=${clase}&codtit=${codtit}&codpro=${encodeURIComponent(codpro)}&vencom=${vencom}&clase2=${clase2}&clase3=${clase3}&clase4=${clase4}&clase5=${clase5}&clase6=${clase6}`);
    }

    /*Filtrar clase codigo*/
    buscarPorCodigoClase(tipinv:number,clase:number,descodigo:string){
        this.apiService.setUrlPathApi(`articulo/v2/${tipinv}/clases/${clase}/codigos`);
        return this.apiService.execGetQueryJson(`?descodigo=${encodeURIComponent(descodigo)}`);
    }
}